// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__4QHUk","imageUploader":"EGiftCard_imageUploader__Etovz"};